import LegalPage from "@/pages/LegalPage";

export default function Rgpd() {
  return (
    <LegalPage overline="Documento legal" title="Conformidade RGPD">
      <p>
        Esta página resume, em linguagem simples, a forma como o serviço Sua Piscina PT cumpre o Regulamento Geral de Proteção de Dados (Regulamento UE 2016/679). Para o detalhe completo, consulte a Política de Privacidade.
      </p>

      <h2>Princípios que seguimos</h2>
      <p>
        Tratamos apenas os dados estritamente necessários, com finalidade clara, durante o tempo justificado pelo serviço. Não vendemos dados, não os usamos para perfis publicitários e não os partilhamos sem autorização do proprietário.
      </p>

      <h2>Base legal do tratamento</h2>
      <p>
        O tratamento dos dados submetidos no formulário tem por base o consentimento explícito do proprietário, manifestado no momento da submissão, e a execução do serviço solicitado.
      </p>

      <h2>Segurança</h2>
      <p>
        Os dados são armazenados junto de fornecedores técnicos de alojamento e base de dados com medidas de segurança adequadas, com acesso restrito ao estúdio. As fotografias submetidas são utilizadas apenas para a simulação solicitada e nunca publicadas sem autorização escrita.
      </p>

      <h2>Os seus direitos</h2>
      <p>
        Tem direito a aceder, corrigir, apagar, limitar, portar ou opor-se ao tratamento dos seus dados. Pode também retirar o consentimento a qualquer momento. Para exercer qualquer destes direitos, basta enviar um email para hello@suapiscinapt.com com a indicação clara do que pretende.
      </p>

      <h2>Reclamações</h2>
      <p>
        Caso considere que os seus direitos não estão a ser respeitados, pode apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD) em{" "}
        <a
          href="https://www.cnpd.pt"
          target="_blank"
          rel="noopener noreferrer"
          className="editorial-link"
        >
          www.cnpd.pt
        </a>
        .
      </p>
    </LegalPage>
  );
}
